export default {
    name: "skeleton",
    data () {
        return{
            loginBtn: {
                state: false,
                data: [
                    { title: '商户登录', href: 'http://houtai.liantuofu.com/index'},
                    { title: '服务商登录', href: 'http://ms.liantuobank.com/'},
                    { title: '老版商户后台', href: 'http://houtai.huishouyin.cn/51club/manage/staticPage.in?page=newpage/login'}
                ]
            },
            menu: [
                {
                    state: false,
                    title: '支付产品',
                    height: '240px',
                    data: [
                        { title: '支付产品概览', type: 'router', href: '/payOverview'},
                        { title: '收款小精灵', type: 'router', href: '/payElves'},
                        { title: '数字前台', type: 'router', href: '/payPos'},
                        { title: '小精灵PRO版软件', type: 'router', href: '/paySoftware'},
                        { title: '收银硬件', type: 'router', href: '/payHardware'},
                        { title: '小精灵商户通', type: 'router', href: '/payMerchant'}
                    ]
                },
                {
                    state: false,
                    title: '私域会员产品',
                    height: '200px',
                    data: [
                        { title: '私域会员产品概览', type: 'router', href: '/digitalizeOverview'},
                        { title: '电子会员卡', type: 'router', href: '/digitalizeCard'},
                        { title: '商家小程序', type: 'router', href: '/digitalizeApplets'},
                        { title: '商户管理后台', type: 'router', href: '/digitalizeBackstage'},
                        { title: '数字化运营', type: 'router', href: '/digitalizeOverview?type=operate'}
                    ]
                },
                {
                    state: false,
                    title: '行业解决方案',
                    height: '320px',
                    data: [
						{ title: '7+N数字方案概览', type: 'router', href: '/n7digitalOverview'},
                        { title: '数字零售方案', type: 'router', href: 'digitalizeRetail', state: true},
						{ title: '数字餐饮方案', type: 'router', href: 'digitalizeRestaurant', state: true},
                        { title: '数字加油站方案', type: 'router', href: '/gasStation', state: true},
						{ title: '优选营销方案', type: 'router', href: '/marketingVersion'},
						{ title: '高级营销方案', type: 'router', href: '/advancedMarketing'},
						{ title: '数字商盟平台方案', type: 'router', href: '/businessUnion'},
						{ title: '数字商圈方案', type: 'href', href: 'https://www.yuque.com/lt/jjfa/oe2lq1'},
					]
                },
				{
					state: false,
					title: '开放平台',
					height: '120px',
					data: [
						{ title: '产品亮点', type: 'router', href: '/productHighlights'},
						{ title: '接入指南', type: 'href', href: 'https://liantuo.feishu.cn/docs/doccnmBLvG3pkAN0jFkykv4XZ7e'},
						{ title: '开发文档', type: 'href', href: 'https://www.showdoc.com.cn/liantuofu?page_id=721259087608792'}
					]
				},
                {
                    state: false,
                    title: '行业案例',
                    height: '240px',
                    data: [
                        { title: '零售案例', type: 'router', href: '/caseRetail'},
                        { title: '餐饮案例', type: 'router', href: '/caseRestaurant'},
                        { title: '加油站案例', type: 'router', href: '/caseGas'},
                        { title: '休闲娱乐案例', type: 'router', href: '/caseAmusement'},
                        { title: '校园案例', type: 'router', href: '/caseCampus'},
                        { title: '酒店案例', type: 'router', href: '/caseHotel'}
                    ]
                },
                {
                    state: false,
                    title: '企业动态',
                    height: '200px',
					showIcon: true,
                    data: [
						{ title: '活动与课程', type: 'router', href: '/activityCurriculum', state: true},
                        { title: '市场动向', type: 'href', href: 'https://mp.weixin.qq.com/mp/appmsgalbum?__biz=MzI3NDUxNzY1Mw==&action=getalbum&album_id=2667167290135871490#wechat_redirect'},
                        { title: '最新案例', type: 'href', href: 'https://mp.weixin.qq.com/mp/appmsgalbum?__biz=MzI3NDUxNzY1Mw==&action=getalbum&album_id=2191946384755458059#wechat_redirect'},
                        { title: '产品百科', type: 'href', href: 'https://mp.weixin.qq.com/mp/appmsgalbum?__biz=MzI3NDUxNzY1Mw==&action=getalbum&album_id=2532737415799832578#wechat_redirect'},
						{ title: '产品更新', type: 'href', href: 'https://mp.weixin.qq.com/mp/appmsgalbum?__biz=MzI3NDUxNzY1Mw==&action=getalbum&album_id=2191972230157369345#wechat_redirect'},
					]
                },
                {
                    state: false,
                    title: '帮助中心',
                    height: '80px',
                    data: [
                        { title: '商户帮助中心', type: 'href', href: 'https://liantuoshuke.yuque.com/docs/share/0c546da7-51c8-4dc5-8aea-1b051d72d7bc#e5NMU'},
                        { title: '服务商下载中心', type: 'href', href: 'http://www.huishouyin.cn/download.html'},
                    ]
                },
                {
                    state: false,
                    title: '关于我们',
                    height: '200px',
                    data: [
                        { title: '公司介绍', type: 'router', href: '/lianTuoCompany'},
                        { title: '招纳贤才', type: 'router', href: '/lianTuoRecruit'},
                        { title: '在联拓面试', type: 'router', href: '/lianTuoInterview'},
                        { title: '在联拓成长', type: 'router', href: '/lianTuoGrowUp'},
                        { title: '在联拓生活', type: 'router', href: '/lianTuoLife'},
                    ]
                }
            ],
            menuShow: false
        }
    },
    methods: {
        menuDown(index){
            let _this = this;
            if(_this.menu[index].state === false){
                let menuLength = _this.menu.length;
                let a;
                for(a=0; a<menuLength; a++){
                    _this.menu[a].state = false;
                }
                _this.menu[index].state = true;
            }else{
                _this.menu[index].state = false;
            }
        }
    }
};
